import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// import screenshot
import watchdogReset from "../../assets/img/docs/watchdog-5.png";

const ResetWatchdog = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className="py-5 reset-watchdog-docs">
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              {/* Title */}
              <Card.Title className="display-6 mb-3">
                {t("documentation.watchdog.reset.title")}
              </Card.Title>

              {/* Description */}
              <Card.Text className="text-muted mb-3">
                {t("documentation.watchdog.reset.description")}
              </Card.Text>

              {/* How to Access */}
              <h5 className="fw-semibold mt-4 mb-2">
                {t("documentation.watchdog.reset.howToAccess.title")}
              </h5>
              <p className="mb-3 text-muted">
                {t("documentation.watchdog.reset.howToAccess.description")}
              </p>

              {/* Screenshot */}
              <Row className="justify-content-center mt-3">
                <Col md={8}>
                  <Image
                    src={watchdogReset}
                    alt="Reset Watchdog screenshot"
                    className="section-image"
                    rounded
                    fluid
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetWatchdog;
